import { useState } from 'react';

import { theme } from '@revenuemarket/design';
import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';
import { Refresh } from '@revenuemarket/ui/Icon';
import { mixpanelTrack } from '@revenuemarket/utils';
import { Button, Drawer } from 'antd';
import { CompanyUserPermission } from '~apis/role/type';
import { postIntegratedScraping } from '~apis/scrape';
import { PermissionGuard } from '~components/Role/PermissionGuard';
import { AnalyzeDashboard } from '~components/ScrapeStatus/AnalyzeDashboard';
import useGetIntegratedScrapeStatus from '~hooks/queries/scraping/useGetIntegratedScrapeStatus';
import { useCompanyId } from '~hooks/useCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';

import { mapText } from './ScrapeBtn';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ScrapeStatusDrawer = ({ isOpen, onClose }: Props) => {
  const [disableClick, setDisableClick] = useState(false);
  const { companyId } = useCompanyId();
  const { data: scrapeStatusData, refetch } = useGetIntegratedScrapeStatus(companyId as string);
  const scrapeStatus = scrapeStatusData?.Data?.data;

  const onScrape = async () => {
    mixpanelTrack(MIXPANEL_EVENT.SCRAPE.DEFAULT);
    const response = await postIntegratedScraping(companyId as string);

    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('수집 요청이 완료되었습니다.');
      setDisableClick(true);
      onClose();
      refetch();
    } else {
      Toast.error('수집 요청에 실패했습니다.');
    }
  };

  const loading = scrapeStatus?.overallStatus === 'IN_PROGRESS';

  return (
    <Drawer
      title="상세 수집 현황"
      placement={'right'}
      width={500}
      onClose={onClose}
      open={isOpen}
      extra={
        <PermissionGuard required={CompanyUserPermission.CAN_MANAGE_DATA_INTEGRATION}>
          <Button
            loading={loading}
            disabled={disableClick || loading}
            onClick={() => onScrape()}
            icon={<Refresh width={16} height={16} fill={theme.colorTokens.iconDefault} />}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {mapText(scrapeStatus?.overallStatus)}
          </Button>
        </PermissionGuard>
      }
    >
      <AnalyzeDashboard onScrape={onScrape} />
    </Drawer>
  );
};

export default ScrapeStatusDrawer;
